<template>
  <div>
    <custom-actions :title="productType === '1' ? '精炼车间' : '包装车间'">
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/productmanage/add?productType=' + productType)">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="配方" prop='productName'>
          <el-input clearable v-model="searchForm.productName" placeholder="配方" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="配方" prop="productName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="产品编号" prop="productCode"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="产品类型" prop="productType">
          <template v-slot="{ row }">
            {{ productTypeMap.get(row.productType) || '--' }}
          </template>
        </el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="200" :show-overflow-tooltip="true" label="操作时间" prop="ctime"></el-table-column>

        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <template>
              <el-button type="text" v-if="hasEdit" @click=" $router.push('/productmanage/edit?productId=' + row.productId)">编辑</el-button>
              <el-button type="text" @click="$router.push('/productmanage/detail?productId=' + row.productId)">详情</el-button>
              <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.productId)">删除</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { productType } from '@/utils/dict'
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'ProductManage',
  mixins: [keepAlive],
  data() {
    return {
      productTypeMap: productType,
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        productName: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    productType() {
      return this.$route.query.productType
    },
    buttonList() {
      // return this.$store.state.buttonList.map(item => item.butCode)
      return this.$store.getters.getMenuByCode(this.menuCode)
    },
    menuCode() {
      return this.productType === '1' ? 'JLCJ' : 'BZCJ'
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    }
  },
  watch: {
    productType(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.onReset()
      }
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.prodManage.selectScProductByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm,
        productType: this.productType
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    },
    deleteRow(productId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.prodManage.deleteScProduct, {
          productId
        }).then(() => {
          this.loadData()
        })
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// .el-select {
//   width: 100%;
// }</style>
<style lang='scss'>
.account-form {

  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
